import { SessionContext as o } from "../contexts/SessionContext.js";
import { useContext as t } from "react";
const n = () => t(o);
export {
  n as useSessionContext
};
//# sourceMappingURL=useSessionContext.js.map
